var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"height":"80vh"}},[_c('v-row',[_c('v-col',[_c('vue-jitsi-meet',{ref:"jitsiRef",staticStyle:{"height":"80vh"},attrs:{"domain":"meet.jit.si","options":_vm.jitsiOptions}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }